export default function Location() {
  return (
    <section id="location" className="py-20 bg-[#FAF8F5]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-10">
          <h2 className="text-[26px] font-bold text-[#2C2C2C] mb-3">오시는 길</h2>
          <p className="text-[15px] text-[#666666]">
            편안하게 찾아오실 수 있도록 안내해드립니다
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10">
          <div className="rounded-2xl overflow-hidden shadow-lg h-[420px]">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3186.770533119447!2d127.09982237565438!3d36.99141017219321!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x357b3af5012c635d%3A0xa59edcff9f2cd1c6!2z6rK96riw64-EIO2Pie2DneyLnCDspJHslZnroZwgMTc2!5e0!3m2!1sko!2skr!4v1773436023494!5m2!1sko!2skr"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="마음쉼터 위치 - 경기도 평택시 중앙로 176"
            ></iframe>
          </div>

          <div className="flex flex-col justify-center">
            <div className="space-y-6">
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 bg-[#A8B5A0]/20 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-map-pin-line text-xl text-[#A8B5A0]"></i>
                </div>
                <div>
                  <h3 className="text-[16px] font-semibold text-[#2C2C2C] mb-1">주소</h3>
                  <p className="text-[13px] text-[#666666] leading-relaxed">
                    경기도 평택시 중앙로 176 2동 2층 219호<br />
                    (합정동 평택합정 SK VIEW 주상복합)<br />
                    롯데슈퍼 앞 건물
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-3">
                <div className="w-10 h-10 bg-[#A8B5A0]/20 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-subway-line text-xl text-[#A8B5A0]"></i>
                </div>
                <div>
                  <h3 className="text-[16px] font-semibold text-[#2C2C2C] mb-1">대중교통</h3>
                  <p className="text-[13px] text-[#666666] leading-relaxed">
                    지하철 1호선 평택역 1번 출구<br />
                    버스 1220, 1311, 1150, 1108<br />
                    평택여중사거리 하차
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-3">
                <div className="w-10 h-10 bg-[#A8B5A0]/20 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-parking-box-line text-xl text-[#A8B5A0]"></i>
                </div>
                <div>
                  <h3 className="text-[16px] font-semibold text-[#2C2C2C] mb-1">주차 안내</h3>
                  <p className="text-[13px] text-[#666666] leading-relaxed">
                    건물 지하 주차장 이용 가능<br />
                    상담 이용 시 2시간 무료 주차<br />
                    (주차권은 센터에서 제공)
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-3">
                <div className="w-10 h-10 bg-[#A8B5A0]/20 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-phone-line text-xl text-[#A8B5A0]"></i>
                </div>
                <div>
                  <h3 className="text-[16px] font-semibold text-[#2C2C2C] mb-1">문의 전화</h3>
                  <p className="text-[13px] text-[#666666] leading-relaxed">
                    010-4827-0275<br />
                    평일 10:00 - 20:00<br />
                    토요일 10:00 - 15:00<br />
                    <span className="text-[12px] text-[#888888]">(사전예약 후 20:00까지 가능)</span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
